import React from "react";
import Heading from "./Main page/Carousal/Heading";

function Services() {
  return (
    <>
      <div className="p-4 ">
        <Heading heading="Services" />
        <div className="flex justify-around items-center py-5 font-fancy text-xl [&>*]:text-center">
          <div className="">
            <img className="w-24" src="./Images/undraw_Eating_together_re_ux62.png" alt="img" />
            <p className="">Dine in</p>
          </div>
          <div className="">
           <img className="w-24 mb-5" src="./Images/undraw_takeout_boxes_ap54.png" alt="img" />
            <p>TakeAway</p>
          </div>
          <div className="">
           <img className="w-32 mb-3" src="./Images/undraw_On_the_way_re_swjt.png" alt="" />
            <p>Delivery</p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Services;
